import React from "react";

import { getMuted, setMuted, subscribeMuted } from "../sound";

// React adapter over the sound module's mute state. The module is the
// source of truth (so non-React code in engines/scoring can check mute
// synchronously without prop-drilling), and this hook just subscribes
// any component that wants to render against it.
//
// Returns [muted, setMutedFn] — same shape as useState — so the toolbar
// button can drop it in like any other piece of local state.
export default function useSoundMuted() {
  const subscribe = React.useCallback((cb) => subscribeMuted(cb), []);
  const muted = React.useSyncExternalStore(subscribe, getMuted, getMuted);
  return [muted, setMuted];
}
